import React from 'react';
import MasterConfig from '../../config/Master';
import { TOSPath } from '../../utils/helpers';
import { getPaymentTheme } from '../../style';
import styled from '@emotion/styled';
import { useTheme } from '@material-ui/core/styles';

const Content = styled('div')(() => {
  const theme = useTheme();

  return {
    color: getPaymentTheme().TERMS.color,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px' /* 125% */,
    letterSpacing: '-0.32px',
    maxWidth: 280,
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    [theme.breakpoints.up('md_two')]: {
      maxWidth: 564,
    },
    [theme.breakpoints.down(639.05)]: {
      maxWidth: '100%',
      fontSize: 12,
      lineHeight: '15px',
      letterSpacing: '-0.3px',
    },
  };
});

const Container = styled('div')({
  textAlign: 'center',
  marginTop: 30,
  borderBottom: '1px  solid #E21D4A',
  paddingBottom: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

interface IBillingTermsAndCondition {
  userCountry: string;
}

const BillingTermsAndCondition = ({ userCountry }: IBillingTermsAndCondition): React.ReactElement => {
  return (
    <Container>
      <Content>
        By submitting the payment, you agree to the purchasing <br />
        <a
          href={`${MasterConfig.FULL_URL}/${TOSPath(userCountry)}`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline', color: '#2B8FD7' }}
        >
          <b>Terms & Conditions</b>
        </a>
      </Content>
    </Container>
  );
};

export default BillingTermsAndCondition;
